import createIcon from '../../createIcon';

/**
 * @component @name Pause
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNiAxOUgxMFY1SDZWMTlaTTE0IDVWMTlIMThWNUgxNFoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Pause = createIcon('Pause', [
  ['path', { d: 'M6 19H10V5H6V19ZM14 5V19H18V5H14Z', key: '3b419t' }],
]);

export default Pause;
